/** @format */
import angular from 'angular';
import _ from 'lodash';
import { ModalService } from 'sis-common';
import { assessmentItemSelectorModule } from '../assessmentItem/assessmentItemSelector.dir';
import { BasicGroupingPanelComponent } from '../grouping-panel/basic-grouping-panel.component';
import { referredObjectSelectEditorModule } from '../object/referredObjectSelectEditor.dir';
import { AddCourseUnitRealisationDialogComponent } from './addCourseUnitRealisationDialog.component';
import addCourseUnitRealisationDialogTpl from './addCourseUnitRealisationDialog.tpl.html';

export const addCourseUnitRealisationDialogModule = 'sis-components.addCourseUnitRealisationDialog';

addCourseUnitRealisationDialogController.$inject = [
    'commonCourseUnitService',
    'commonAssessmentItemService',
    'commonCurriculumPeriodService',
    'universityService',
    'curriculumPeriodModel',
    'courseUnitRealisationTypeModel',
    'universityModel',
    'constraintService',
    '$scope',
];
addCourseUnitRealisationDialogService.$inject = ['modalService', '$q'];

angular
    .module(addCourseUnitRealisationDialogModule, [
        'sis-common.university',
        'sis-components.service.courseUnitRealisationService',
        referredObjectSelectEditorModule,
        assessmentItemSelectorModule,
        'sis-components.service.courseUnitService',
        'sis-components.service.assessmentItemService',
        'sis-components.service.curriculumPeriodService',
        'sis-components.model.curriculumPeriod',
        'sis-components.model.courseUnitRealisationType',
        'sis-components.model.university',
        'sis-common.form',
        BasicGroupingPanelComponent.downgrade.moduleName,
        ModalService.downgrade.moduleName,
    ])
    .factory('addCourseUnitRealisationDialog', addCourseUnitRealisationDialogService)
    .component('addCourseUnitRealisationDialog', {
        bindings: {
            close: '&',
            dismiss: '&',
            resolve: '<',
        },
        controller: addCourseUnitRealisationDialogController,
        controllerAs: 'ctrl',
        template: addCourseUnitRealisationDialogTpl,
    });

function addCourseUnitRealisationDialogService(modalService, $q) {
    return {
        open: courseUnitRealisation =>
            modalService.open(AddCourseUnitRealisationDialogComponent, { courseUnitRealisation }).result.catch(() => $q.reject()),
    };
}

function addCourseUnitRealisationDialogController(
    commonCourseUnitService,
    commonAssessmentItemService,
    commonCurriculumPeriodService,
    universityService, // NOSONAR
    curriculumPeriodModel,
    courseUnitRealisationTypeModel,
    universityModel,
    constraintService,
    $scope,
) {
    const ctrl = this;

    const setDefaultCurriculumPeriod = () => {
        commonCurriculumPeriodService.getCurrentCurriculumPeriod(ctrl.selectedUniversityId).then(result => {
            ctrl.selectedCurriculumPeriod = result;
        });
    };

    ctrl.$onInit = () => {
        ctrl.assessmentItem = {};

        ctrl.courseUnitRealisation = ctrl.resolve.courseUnitRealisation;
        ctrl.curriculumPeriodModel = curriculumPeriodModel;
        ctrl.selectedAssesmentItem = undefined;
        ctrl.selectedCourseUnit = undefined;
        ctrl.selectedCurriculumPeriod = undefined;
        ctrl.courseUnitRealisationTypeModel = courseUnitRealisationTypeModel;
        ctrl.selectedCourseUnitRealisationTypeUrn = undefined;
        ctrl.courseUnitService = commonCourseUnitService;
        ctrl.assessmentItemService = commonAssessmentItemService;
        ctrl.universityModel = universityModel;
        ctrl.selectedUniversityId = universityService.getCurrentUniversityOrgId();
        ctrl.validationGroups = ['Draft', 'Active'];
        ctrl.courseUnitRealisationConstraints = constraintService.getTypeConstraints('CourseUnitRealisation', ctrl.validationGroups);

        commonCurriculumPeriodService.findAll();
        setDefaultCurriculumPeriod();
    };

    ctrl.selectCurriculumPeriod = obj => {
        ctrl.selectedCurriculumPeriod = obj;
    };

    ctrl.selectUniversity = obj => {
        if (ctrl.selectedUniversityId !== obj.id) {
            ctrl.selectedUniversityId = obj.id;
            setDefaultCurriculumPeriod();
        }
    };

    ctrl.ok = () => {
        const courseUnitRealisationType = courseUnitRealisationTypeModel.get(ctrl.selectedCourseUnitRealisationTypeUrn);

        ctrl.courseUnitRealisation.assessmentItemIds = [ctrl.selectedAssessmentItem.id];
        ctrl.courseUnitRealisation.nameSpecifier = _.cloneDeep(ctrl.selectedCourseUnit.name);
        ctrl.courseUnitRealisation.name = _.cloneDeep(courseUnitRealisationType.name);
        ctrl.courseUnitRealisation.courseUnitRealisationTypeUrn = ctrl.selectedCourseUnitRealisationTypeUrn;
        ctrl.courseUnitRealisation.universityOrgIds = [ctrl.selectedUniversityId];

        if (ctrl.selectedCourseUnit?.cooperationNetworkDetails?.direction === 'OUTBOUND') {
            ctrl.courseUnitRealisation.cooperationNetworkDetails = {
                networks: ctrl.selectedCourseUnit.cooperationNetworkDetails.networks,
                externalId: ctrl.courseUnitRealisation.id,
                direction: 'OUTBOUND',
            };
        }

        ctrl.close({ $value: ctrl.courseUnitRealisation });
    };

    ctrl.cancel = () => {
        ctrl.dismiss();
    };

    ctrl.setCourseUnitRealisationTypeUrn = (form, selectedUrn) => {
        ctrl.selectedCourseUnitRealisationTypeUrn = selectedUrn;
        form.$setDirty();
        $scope.$apply();
    };

    // eslint-disable-next-line max-len
    ctrl.isFormValid = form =>
        form.$valid &&
        ctrl.selectedCourseUnitRealisationTypeUrn &&
        ctrl.courseUnitRealisation.activityPeriod.startDate &&
        ctrl.courseUnitRealisation.activityPeriod.endDate;
}
